<script setup lang="ts">
import HubsList from '@/modules/Workspaces/KnowledgeHub/Hubs/HubsList.vue'
import type { Hub } from '@/modules/Workspaces/KnowledgeHub/Hubs/types'
import PageContainer from '@/modules/Workspaces/KnowledgeHub/Layout/PageContainer.vue'
import PageTitle from '@/modules/Workspaces/KnowledgeHub/Layout/PageTitle.vue'
import PageTitleBar from '@/modules/Workspaces/KnowledgeHub/Layout/PageTitleBar.vue'
const demoHubs: Hub[] = [
  {
    id: '1',
    name: 'Hub 1',
    status: 'ready',
    fileCount: 10,
  },
  {
    id: '2',
    name: 'Hub 2',
    status: 'processing',
    fileCount: 20,
  },
  {
    id: '3',
    name: 'Hub 3',
    status: 'error',
    fileCount: 30,
  },
  {
    id: '4',
    name: 'Hub 4',
    status: 'stale',
    fileCount: 40,
  },
]
</script>

<template>
  <PageContainer>
    <PageTitleBar class="mb-10">
      <template #title>
        <PageTitle>Hubs</PageTitle>
      </template>
    </PageTitleBar>
    <HubsList :hubs="demoHubs" />
  </PageContainer>
</template>
